import { ActionContext } from 'vuex';

import { TBaseFilterPayload } from '@/common/types/filter';
import { TApiResponse } from '@/common/types/response';
import { getLocalState } from '@/common/utils/store';

import { TAnalyticsNotesFilter, TAnalyticsNotesForeignTradeTemplateDataMonthly } from '../../types/analytics-notes';
import { ANALYTICS_NOTES_MONTHLY_ACTIONS_NAME, ANALYTICS_NOTES_MONTHLY_MUTATIONS_NAME } from './name';
import { TAnalyticsNotesMonthlyState } from './types';

import { TPaginationParams } from '@/types/meta';
import links from '@/utils/links';
import request from '@/utils/request';

export async function searchForeignTradeTable(
  context: ActionContext<TAnalyticsNotesMonthlyState, unknown>,
  payload: TBaseFilterPayload<TAnalyticsNotesFilter>,
) {
  return request(
    context,
    {
      url: links.ved.analyticsNotes.monthly.getForeignTradeTable,
      name: getLocalState(ANALYTICS_NOTES_MONTHLY_ACTIONS_NAME.searchForeignTradeTable),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}

export async function searchForeignTradeTemplateData(
  context: ActionContext<TAnalyticsNotesMonthlyState, unknown>,
  params: TAnalyticsNotesFilter,
) {
  return (await request(
    context,
    {
      url: links.ved.analyticsNotes.monthly.getForeignTrade,
      name: getLocalState(ANALYTICS_NOTES_MONTHLY_ACTIONS_NAME.searchForeignTradeTemplateData),
      mutate: getLocalState(ANALYTICS_NOTES_MONTHLY_MUTATIONS_NAME.setForeignTradeTemplateData),
      method: 'post',
    },
    params,
  )) as TApiResponse<TAnalyticsNotesForeignTradeTemplateDataMonthly>;
}

export async function searchExportStructureTable(
  context: ActionContext<TAnalyticsNotesMonthlyState, unknown>,
  payload: TBaseFilterPayload<TAnalyticsNotesFilter>,
) {
  return request(
    context,
    {
      url: links.ved.analyticsNotes.monthly.getExportStructure,
      name: getLocalState(ANALYTICS_NOTES_MONTHLY_ACTIONS_NAME.searchExportStructureTable),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}

export async function searchImportStructureTable(
  context: ActionContext<TAnalyticsNotesMonthlyState, unknown>,
  payload: TBaseFilterPayload<TAnalyticsNotesFilter>,
) {
  return request(
    context,
    {
      url: links.ved.analyticsNotes.monthly.getImportStructure,
      name: getLocalState(ANALYTICS_NOTES_MONTHLY_ACTIONS_NAME.searchImportStructureTable),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}

export async function searchExportProductsTable(
  context: ActionContext<TAnalyticsNotesMonthlyState, unknown>,
  payload: TBaseFilterPayload<TAnalyticsNotesFilter & TPaginationParams>,
) {
  return request(
    context,
    {
      url: links.ved.analyticsNotes.monthly.getExportMainGoods,
      name: getLocalState(ANALYTICS_NOTES_MONTHLY_ACTIONS_NAME.searchExportProductsTable),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}

export async function searchImportProductsTable(
  context: ActionContext<TAnalyticsNotesMonthlyState, unknown>,
  payload: TBaseFilterPayload<TAnalyticsNotesFilter & TPaginationParams>,
) {
  return request(
    context,
    {
      url: links.ved.analyticsNotes.monthly.getImportMainGoods,
      name: getLocalState(ANALYTICS_NOTES_MONTHLY_ACTIONS_NAME.searchImportProductsTable),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}
